import React from 'react';
const SvgPlay: React.FC<React.SVGProps<SVGSVGElement>> = (
  props: React.SVGProps<SVGSVGElement>,
) => {
  return (
    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M21 12v0a9 9 0 01-9 9v0a9 9 0 01-9-9v0a9 9 0 019-9v0a9 9 0 019 9z"
      />
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M10.941 9.058l3.882 2.296a.75.75 0 010 1.291l-3.882 2.296a.75.75 0 01-1.132-.646V9.704a.75.75 0 011.132-.646z"
      />
    </svg>
  );
};
export default SvgPlay;
